import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd } from '@angular/router';
import { isPlatformBrowser, isPlatformServer, Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';
import { MainserviceService } from './mainservice.service';
import { TawkService } from './services/tawk.service';
import { Meta } from '@angular/platform-browser';
import { loadBlog } from './components/action/blog.actions';
import { Store } from '@ngrx/store';
import { Blog } from './components/model/blog';
import { SeoSocialShareService } from 'ngx-seo';
declare function gtag(...args: any[]): void;
declare let $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    Location, {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    MainserviceService
  ]
})
export class AppComponent implements OnInit {
  title = 'Medeil-web';
  location: any;
  routerSubscription: any;
  isVisible = false;
  interndata: any;
  isLoading = true;
  showPreloader = true;
  constructor(private meta: Meta, private router: Router, private mainservice: MainserviceService, @Inject(PLATFORM_ID) private platformId: Object,
    private tawkService: TawkService, private store: Store<{ blog: { blog: Blog[] } }>, private renderer: Renderer2, private seoService: SeoSocialShareService) {
    this.tawkService.loadTawk();
    // this.setSeoMeta();
    // this.setCanonicalURL();
    // this.router.events.pipe(
    //   filter(event => event instanceof NavigationEnd)
    // ).subscribe(() => {
    //   this.addHreflangTags();
    //   // this.setSeoMeta();
    // });
    // this.router.events
    // .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
    // .subscribe(() => {
    //   this.setCanonicalURL();  // Call your method here
    // });
    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     gtag('config', 'G-RSG2HFDK2J', {
    //       'page_path': event.urlAfterRedirects
    //     });
    //   }
    // });

    if (isPlatformBrowser(this.platformId)) {
      this.setCanonicalURL();
      this.addHreflangTags();
      localStorage.setItem('selectedLanguage', "en");
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          gtag('config', 'G-RSG2HFDK2J', {
            'page_path': event.urlAfterRedirects
          });
        }
      });

    }
    setTimeout(() => {
      this.isLoading = false;
    }, 100);
    this.router.events.subscribe(event => {
      if (this.router.url === '/terms-condition') {
        this.isVisible = false;
      } else {
        // this.isVisible = true;
      }
    });
    this.store.dispatch(loadBlog())
  }


  setCanonicalURL() {
    let origin = window.location.origin;

    // Ensure www prefix for production
    if (!origin.includes('localhost') && !origin.startsWith('https://www.')) {
      origin = origin.replace('https://', 'https://www.');
    }

    const supportedLanguages = ['en', 'fr', 'es', 'pt'];
    let lang = 'en';

    const urlParts = location.pathname.split('/');
    if (supportedLanguages.includes(urlParts[1])) {
      lang = urlParts[1];
    }

    // Correct the path for canonical URL
    let pagePath = location.pathname.replace(/^\/[a-z]{2}(\/|$)/, '/');
    if (pagePath === '/') pagePath = ''; // Avoid trailing slash issues

    const canonicalUrl = `${origin.replace(/\/$/, '')}/${lang}/${pagePath.replace(/^\/+/, '')}`;

    let link: HTMLLinkElement = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);

    console.log('Canonical URL Set:', canonicalUrl);
  }

  // addHreflangTags() {
  //   let origin = window.location.origin;

  //   // Avoid localhost in production
  //   if (origin.includes('localhost')) return;

  //   // Ensure www prefix
  //   if (!origin.startsWith('https://www.')) {
  //     origin = origin.replace('https://', 'https://www.');
  //   }

  //   const languages = ['en', 'fr', 'es', 'pt'];
  //   const urlParts = location.pathname.split('/');
  //   const currentLang = languages.includes(urlParts[1]) ? urlParts[1] : 'en';

  //   let pagePath = location.pathname.replace(/^\/[a-z]{2}(\/|$)/, '/');
  //   if (pagePath === '/') pagePath = ''; // Avoid issues with empty path

  //   // Remove old alternate links
  //   document.querySelectorAll("link[rel='alternate']").forEach(el => el.remove());

  //   // Add hreflang links for all languages
  //   languages.forEach(lang => {
  //     const href = `${origin.replace(/\/$/, '')}/${lang}${pagePath.replace(/^\/+/, '')}`;
  //     const link = document.createElement('link');
  //     link.setAttribute('rel', 'alternate');
  //     link.setAttribute('hreflang', lang);
  //     link.setAttribute('href', href);
  //     document.head.appendChild(link);
  //   });

  //   // Add x-default
  //   const xDefaultLink = document.createElement('link');
  //   xDefaultLink.setAttribute('rel', 'alternate');
  //   xDefaultLink.setAttribute('hreflang', 'x-default');
  //   xDefaultLink.setAttribute('href', `${origin.replace(/\/$/, '')}/en${pagePath.replace(/^\/+/, '')}`);
  //   document.head.appendChild(xDefaultLink);
  // }
  // addHreflangTags() {
  //   let origin = window.location.origin;

  //   // Avoid localhost in production
  //   if (origin.includes('localhost')) return;

  //   // Ensure www prefix
  //   if (!origin.startsWith('https://www.')) {
  //     origin = origin.replace('https://', 'https://www.');
  //   }

  //   const languages = ['en', 'fr', 'es', 'pt'];
  //   const urlParts = location.pathname.split('/');
  //   const currentLang = languages.includes(urlParts[1]) ? urlParts[1] : 'en';

  //   let pagePath = location.pathname.replace(/^\/[a-z]{2}(\/|$)/, '/');
  //   if (pagePath === '/') pagePath = ''; // Avoid issues with empty path

  //   // Remove old alternate links
  //   document.querySelectorAll("link[rel='alternate']").forEach(el => el.remove());

  //   // Add hreflang links for all languages
  //   languages.forEach(lang => {
  //     const href = `${origin.replace(/\/$/, '')}/${lang}${pagePath.replace(/^\/+/, '')}`;
  //     const link = document.createElement('link');
  //     link.setAttribute('rel', 'alternate');
  //     link.setAttribute('hreflang', lang);
  //     link.setAttribute('href', href);
  //     document.head.appendChild(link);
  //   });

  //   // Add x-default
  //   const xDefaultLink = document.createElement('link');
  //   xDefaultLink.setAttribute('rel', 'alternate');
  //   xDefaultLink.setAttribute('hreflang', 'x-default');
  //   xDefaultLink.setAttribute('href', `${origin.replace(/\/$/, '')}/en${pagePath.replace(/^\/+/, '')}`);
  //   document.head.appendChild(xDefaultLink);

  //   // 👉 Remove old Content-Language meta if any
  //   document.querySelectorAll("meta[http-equiv='Content-Language']").forEach(el => el.remove());

  //   // 👉 Add new Content-Language meta
  //   const meta = document.createElement('meta');
  //   meta.setAttribute('http-equiv', 'Content-Language');
  //   meta.setAttribute('content', currentLang);
  //   document.head.appendChild(meta);
  // }


  addHreflangTags() {
    let origin = window.location.origin;

    // Avoid localhost in production
    if (origin.includes('localhost')) return;

    // Ensure www prefix and clean up origin
    if (!origin.startsWith('https://www.')) {
      origin = origin.replace('https://', 'https://www.');
    }
    origin = origin.replace(/\/+$/, ''); // Remove any trailing slashes

    const languages = ['en', 'fr', 'es', 'pt'];
    const urlParts = location.pathname.split('/').filter(part => part !== '');
    const currentLang = languages.includes(urlParts[0]) ? urlParts[0] : 'en';

    // Get the path without language prefix
    let pagePath = urlParts.length > 1 ? '/' + urlParts.slice(1).join('/') : '';
    pagePath = pagePath.replace(/\/+$/, ''); // Remove trailing slashes

    // Remove old alternate links
    document.querySelectorAll("link[rel='alternate']").forEach(el => el.remove());

    // Add hreflang links for all languages
    languages.forEach(lang => {
      const href = `${origin}/${lang}${pagePath ? pagePath + '/' : '/'}`;
      const link = document.createElement('link');
      link.setAttribute('rel', 'alternate');
      link.setAttribute('hreflang', lang);
      link.setAttribute('href', href);
      document.head.appendChild(link);
    });

    // Add x-default
    const xDefaultLink = document.createElement('link');
    xDefaultLink.setAttribute('rel', 'alternate');
    xDefaultLink.setAttribute('hreflang', 'x-default');
    xDefaultLink.setAttribute('href', `${origin}/en${pagePath ? pagePath + '/' : '/'}`);
    document.head.appendChild(xDefaultLink);

    // Remove old Content-Language meta if any
    document.querySelectorAll("meta[http-equiv='Content-Language']").forEach(el => el.remove());

    // Add new Content-Language meta
    const meta = document.createElement('meta');
    meta.setAttribute('http-equiv', 'Content-Language');
    meta.setAttribute('content', currentLang);
    document.head.appendChild(meta);
  }










  // ngAfterViewInit(): void {
  //   if (isPlatformBrowser(this.platformId)) {
  //     this.addHreflangTags();
  //   }
  // }

  ngOnInit() {



    const pageVisited = window.location.href;
    this.mainservice.trackVisitor(pageVisited);


    if (isPlatformServer(this.platformId)) {
      console.log('Rendering on server');
    } else {
      console.log('Rendering on browser');
    }

    if (isPlatformBrowser(this.platformId)) {
      this.addJsonLd();


      this.isVisible = !this.mainservice.hasConsented();

      const ip$ = this.mainservice.getIpAddress1();
      if (ip$) {
        ip$.subscribe(data => {
          console.log(data);
          this.interndata = data;

          sessionStorage.setItem('dialcode', data.country_calling_code);
          sessionStorage.setItem('countryname', data.country_name);
          sessionStorage.setItem('cityname', data.city);
          sessionStorage.setItem('timezone', data.timezone);
          sessionStorage.setItem('ip', data.ip);

          const dial$ = this.mainservice.getdailcode(data.ip);
          if (dial$) {
            dial$.subscribe(data => {
              console.log(data);
              if (data?.language?.[0]?.[2]) {
                sessionStorage.setItem('language', data.language[0][2]);
              }
            });
          }
        });
      }

      this.recallJsFuntions();
    }


    // this.mainservice.getVisitorInfo();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showPreloader = false;
      }
    });
  }


  recallJsFuntions() {
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          $('.preloader').fadeIn('slow');
        }
      });
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
      .subscribe(event => {
        $.getScript('./assets/js/custom.js');
        $('.preloader').fadeOut('slow');
        this.location = this.router.url;
        if (!(event instanceof NavigationEnd)) {
          return;
        }
        window.scrollTo(0, 0);
      });
  }

  accept(): void {
    this.mainservice.internData(this.interndata).subscribe(data => {
      console.log(data);

    })
    this.mainservice.setConsent(true);
    this.isVisible = false;
  }

  decline(): void {
    this.mainservice.setConsent(false);
    this.isVisible = false;
  }
  addJsonLd() {
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "Offer",
      "priceCurrency": "USD",
      "availability": "https://schema.org/InStock",
      "url": "https://www.medeil.com/en/allotmed-medical-supply",
      "keywords": "Distribution management software, Supply chain optimization, Allotmed software, Inventory tracking, Order management, Supplier management, Cloud-based distribution, On-premises deployment"
    };

    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    this.renderer.appendChild(document.head, script);
  }

  openChat() {
    this.tawkService.openChat(); // Open chat when clicking the icon
  }
}